import { match, P } from "ts-pattern";

type OfficeSettings = {
  __typename?: "OfficeSettings";
  careRecipientSignatureRequired: boolean;
  caregiverSignatureRequired: boolean;
};

type Office = {
  __typename?: "Office";
  id: string;
  settings: OfficeSettings | null;
};

type CareRecipientRole = {
  __typename?: "CareRecipientRole";
  office: Office;
};

export const atleastOneSignatureEnabled = (
  officeId: string | undefined,
  roles: CareRecipientRole[] | undefined,
): boolean => {
  return match({ officeId, roles })
    .with(
      { officeId: P.string, roles: P.array(P.any) },
      ({ officeId, roles }) =>
        roles.some(
          (role) =>
            role.office?.id === officeId &&
            (role.office.settings?.careRecipientSignatureRequired ||
              role.office.settings?.caregiverSignatureRequired),
        ),
    )
    .otherwise(() => false);
};
